import { Toaster as SonnerToaster, toast } from 'sonner';

/**
 * App-wide toast renderer. Mount once near the root.
 * Sonner is the toast library the plan calls for; we wrap it lightly
 * here so the rest of the app imports from a single place.
 */
export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      richColors={false}
      closeButton={false}
      // Default duration applies to toasts that don't override it. The Undo
      // toasts inside useHabitLog explicitly extend to 4s; plain confirmations
      // pass through this default.
      duration={2500}
      // Desktop: lift toasts clear of the docked CommandBar (the ~56px bottom
      // "Ask Brainday" bar on the Today route) so Undo/confirmations don't sit
      // on top of it at md/lg widths where there's no Narrator rail to absorb them.
      offset={{ bottom: '76px', right: '16px' }}
      // Mobile: lift above the bottom-tab bar so toasts don't intercept
      // navigation taps. BottomTabs height + safe-area-inset-bottom is roughly
      // 88-104px on iPhones with home indicators.
      mobileOffset={{ bottom: '110px', right: '16px' }}
      toastOptions={{
        classNames: {
          // !break-words: toasts interpolate user content ("Habit deleted — {name}")
          // and overflow-wrap inherits to sonner's title/description nodes.
          // !pointer-events-auto: a modal Radix Sheet/Dialog sets
          // pointer-events:none on <body>, which the toast inherits — without
          // this, clicks on Undo fall THROUGH the toast into whatever sits
          // beneath it (e.g. the habit week grid under the detail sheet).
          toast:
            '!pointer-events-auto !bg-card !border !border-line-2 !text-t1 !rounded-xl !text-body !shadow-card !break-words',
          description: '!text-t2',
          actionButton: '!bg-t1 !text-canvas !rounded-md !px-2.5 !py-1 !text-caption',
          cancelButton: '!bg-rail !text-t2 !rounded-md !px-2.5 !py-1 !text-caption',
        },
      }}
    />
  );
}

export { toast };
